<template>
  <div :class='blockPan ? "relative" : ""'>
    <runner-game ref='runnerGame' v-if="state === 'playing'" class="grow"
      :options='{}'
      :gamedata='playdata'
      :user="pbcUser"
      :paused="isPaused"
      :has-custom-loader='true'
      :enable-black-list-message='false'
      :user-freeplay-limit-reached='false'
      :new-user='false'
      :initial-transforms='transformsAndSource.transforms'
      :layers='transformsAndSource.from.layers'
      :tick-resolution='100'
      :enable-letterbox='true'
      @game-started='onGameStarted'
      @game-state="onUpdateGameState"
      @tick='onTick'
      :data='{}'
    />
      <div v-else class="w-full h-full flex flex-row" style='background-color: rgba(255,255,255,0.3)'>
        <game-state 
          class="mx-4 md:mx-auto max-w-md max-h-md self-center"
          :state="state"
          :message="stateMessage"
          @restart="state = 'playing'"
          />
      </div>
    <editor-player-toolbar v-if='enableToolbar'
                           class="w-full flex-none"
                           @edit="$emit('edit')"
                           @playpause="isPaused = !isPaused"
                           @post='$emit("post")'
                           :title='title'
                           :paused="isPaused" @step='step' />
    <pbc-alert v-if='panBlocked' v-model='panBlocked'>
      <h3 class="text-white">To move or scale items, select 'Place'.</h3>
    </pbc-alert>

    <div v-if='busyRestarting' class='absolute left-0 right-0 top-0 bottom-0 my-auto bg-black opacity-50'>
      <div class="spinner mt-12 mx-auto text-lg" />
    </div>

    <slot name="default" />
  </div>
</template>
<script>
import Vue from 'vue';
import PbcAlert from '@ui/molecules/PbcAlert.vue';
import { cloneDeep } from 'lodash';
import EditorPlayerToolbar from '@ui/molecules/EditorPlayerToolbar.vue';
import getProvider from '@/ui/apiprovider.js';
import GameState from '@ui/organisms/GameState.vue';
const RunnerGame  = () => import(/* webpackChunkName: "play" */ '@/play/components/RunnerGame.vue');
export default {
  provide: getProvider,
  props: {
    gamedata: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    enableToolbar: {
      type: Boolean,
      default: true
    },
    blockPan: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    RunnerGame,
    GameState,
    PbcAlert,
    EditorPlayerToolbar
  },
  methods: {
    onTick({dt,timeSinceStart}) {
      this.$emit('tick', {
        dt,
        timeSinceStart
      });
    },
    clearHighlightTransformSingle() {
      if (this.$refs.runnerGame && this.$refs.runnerGame.Systems) {
        this.$refs.runnerGame.Systems.clearHighlightTransformSingle();
      }
    },
    highlightTransform(id, color) {
      this.__highlightTransform = id;
      console.log('set the highlight thing lol', id);
      if (this.$refs.runnerGame && this.$refs.runnerGame.Systems) {
        this.$refs.runnerGame.Systems.setHighlighTransformSingle(this.__highlightTransform, color);
      }
    },
    async restartGame() {
      console.log('restarting game');
      if (this.$refs.runnerGame) {
        clearTimeout(this.__setRestartingTimer);
        this.__setRestartingTimer = setTimeout( () => {
          this.busyRestarting = true;
        }, 300);
        this.playdata = cloneDeep(this.gamedata)

        Vue.nextTick( async () => {
          await this.$refs.runnerGame.restartGame(true)
          clearTimeout(this.__setRestartingTimer);
          this.busyRestarting = false;
        });
      }
    },
    onGameStarted() {
      if (this.blockPan && !this.__addedBlockPan) {
        const pan = new Hammer.Pan({
          threshold:15,
          pointers:1
        })
        const hammer = this.$refs.runnerGame.hammer;
        hammer.add(pan);
        hammer.on('panstart', () => {
          console.log('block pan');
          this.panBlocked = true;
        });
        this.__addedBlockPan = true;
      }
    },
    onUpdateGameState(state,message) {
      console.log('state is', state);
      this.state = state;
      this.stateMessage = message;

    },
    step() {
      this.$refs.runnerGame.onStep();
    }
  },
  data() {
    const playdata = cloneDeep(this.gamedata);
    return {
      pbcUser: {
        id: 'cheese'
      },
      isPaused:false,
      state:'playing',
      stateMessage:'',
      playdata,
      panBlocked: false,
      busyRestarting: false
    }
  },
  watch:{
    'gamedata.game.timelimit'(nv) {
      this.playdata.game.timelimit = nv;
    }
  }
}
</script>
